// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_66fbd05f"};